/** @format */

import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";

//json2mq
import json2mq from "json2mq";

//react-slick
import Slider from "react-slick";

//helpers
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    mt: { xs: "94px", md: "113px", lg: "128px", xl: "143px" },
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  title: {
    color: theme.palette.red.main,
    fontSize: { xs: "14px", md: "16px" },
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontFamily: theme.typography.montserrat.semibold,
  },
  subtitle: {
    color: theme.palette.blue.main,
    fontSize: { xs: "32px", md: "43px", lg: "54px", xl: "65px" },
    lineHeight: { xs: "36px", md: "45px", lg: "54px", xl: "65px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: { xs: "center" },
    maxWidth: { xs: "225px", md: "447px", lg: "558px", xl: "667px" },
    height: { xs: "72px", md: "73.25px", lg: "74.5px", xl: "79px" },
    mt: { xs: "16px", md: "22px", lg: "26.5px", xl: "31px" },
    fontWeight: "bold",
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  titleContainer: {
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  sliderContainer: {
    width: "90%",
    height: "140px",
    mt: { xs: "64px", md: "64px", lg: "96px", xl: "96px" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  slider: { display: "flex", maxWidth: isMobile ? "330px" : "100%" },
  span: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrow: {
    color: theme.palette.grey.main,
    fontSize: "30px",
    fontWeight: "bold",
  },
});

const Tools = () => {
  const isMobile = useMediaQuery("(max-width:899px)");

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );
  const md = useMediaQuery(
    json2mq({
      maxWidth: 1200,
      minWidth: 900,
    })
  );
  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1201,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
    })
  );

  const stylesHelper = () => {
    if (xs)
      return {
        img: {
          width: "125px",
          height: "75px",
          objectFit: "contain",
          margin: "16px auto",
        },
      };
    else if (lg || xl)
      return {
        img: {
          width: "177.6px",
          margin: "8px auto",
          height: "90px",
          objectFit: "contain",
        },
      };
    else if (md)
      return {
        img: {
          width: "150px",
          margin: "8px auto",
          height: "80px",
          objectFit: "contain",
        },
      };
  };

  const { pathname } = useLocation();
  const componentName = "Tools";
  const translation = useTranslation(pathname, componentName);
  const { title, subtitle, logosImg } = translation;

  return (
    <Box sx={classes.container}>
      <Box sx={classes.titleContainer}>
        {isMobile ? null : <div style={classes.line}></div>}
        <Typography sx={classes.title}>{title}</Typography>
      </Box>

      <Typography sx={classes.subtitle}>{subtitle}</Typography>

      <Box sx={classes.sliderContainer}>
        {stylesHelper() && (
          <Slider
            slidesToShow={isMobile ? 2 : 3}
            style={classes.slider}
            arrows={false}
            rows={2}
            autoplay={true}
            autoplaySpeed={3000}
          >
            {logosImg.map(({ src, alt }, index) => {
              return (
                <div key={index}>
                  <img src={src} alt={alt} style={stylesHelper().img} />
                </div>
              );
            })}
          </Slider>
        )}
      </Box>
    </Box>
  );
};

export default Tools;
